import api from 'api/apiInstance';

export const termsOfServiceApi = (path: string) => ({
  path,
  GET: () => api.get(path)
});
